/**
 * Lightweight full-page loader shown while per-module auth is being checked.
 * Replaces the brief paint of the protected page that used to flash before
 * the redirect to the role-specific login page.
 */
export const AuthCheckSkeleton = () => (
  <div
    className="min-h-screen flex flex-col items-center justify-center"
    style={{ background: "radial-gradient(ellipse at center, #0A1910 0%, #000000 70%)" }}
    data-testid="module-auth-checking"
  >
    <div className="h-10 w-10 rounded-full border-2 border-emerald-400/40 border-t-emerald-400 animate-spin" />
    <p className="text-xs text-gray-500 mt-3 uppercase tracking-wider">Checking access…</p>
  </div>
);

export default AuthCheckSkeleton;
